export const REF = {
  nh3_mg_l: 0.5,              // Dept limit start
  bod_mg_l: 10,               // <10
  cod_mg_l: 100,              // <100
  chloride_mg_l: 155,         // upper acceptable band (45–155)
  color_hazen: 15,            // 15 Hazen
  do_mg_l: 6.5,               // low DO below 6.5 is bad (per 6.5–8)
  toc_mg_l: 5,                // <5
  doc_mg_l: 4,                // <4
  ph: { lo: 6.5, hi: 9.0 },   // 6.5–9.0
  orp_mv: 300,                // use your lower band (300–500) as baseline for “under” if needed later
  temp_c: 25,                 // target upper bound (15–25)
  tss_mg_l: 100,              // <100
  turbidity_ntu: 20,          // project baseline (since no official limit provided)
  ec_us_cm: 800               // project baseline (until dept defines)
};